const initialState = {
    records: [],
    exceptionRecords: [],
    exceptionLabels: [],
    allExceptionRecords: [],
    treeData: [],
    nodes: [],
    fundsNodes: [],
    authRecords: [],
    auditrecords: [],
    accountsList: [],
    refDataSettings: [],
    hreconData: [],
    taReconOrders: [],
    transactionType: [],
    reconDate: [],
};

export default initialState;
